module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_s_shadow.9227ed09.png";